<template>
  <el-row type="flex" class="work-attentance-record">
    <left-tree class="left-box" @project-change="projectChange" />
    <div class="right-box">
      <div class="top-tit">
        <div class="form-cen-tit" v-if="currLabel">{{ currLabel }}</div>
      </div>
      <el-row type="flex" justify="space-between" class="search-condition ">
        <div class="condition-left">
          <span>考勤日期</span>
          <el-date-picker v-model="params.startDate" value-format="YYYY-MM-DD" style="width: 140px;margin-left:15px;"
            @change="searchData"></el-date-picker>
          -
          <el-date-picker v-model="params.endDate" value-format="YYYY-MM-DD" style="width: 140px;"
            @change="searchData"></el-date-picker>
          <el-button type="primary" @click="toExport" icon="download">导出</el-button>
        </div>
        <el-input v-model="params.query" placeholder="输入姓名和手机号搜索" @change="searchData" clearable class="condition-right">
          <template #append><el-button @click="searchData" icon="search">搜索</el-button></template>
        </el-input>
      </el-row>

      <el-table :data="workAttendances" tooltip-effect="dark" border stripe height="calc(100vh - 265px)"
        row-key="id" default-expand-all v-loading="loading" class="data-table" @selection-change="handleSelectionChange">
        <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
          :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
          :fixed="column.fixed">
        </el-table-column>

        <el-table-column label="操作" width="80" fixed="right">
          <template #default="{row}">
            <el-button type="text" @click="toInfo(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
        :current-page="params.pageNo" :page-size="params.length" @current-change="pageNoChange"
        @size-change="lengthChange">
      </el-pagination>
    </div>
  </el-row>

  <statistics-info v-model="infoVisible" :workAttendance="workAttendance" :params="params" />
</template>

<script>
import { defineComponent } from 'vue';
import { exportStatisticsWorkAttendanceByQuery, statisticsWorkAttendanceByQuery } from '@/api/work/index';
import LeftTree from './LeftTree.vue'
import StatisticsInfo from './StatisticsInfo.vue';
import { mapGetters } from 'vuex';
import { exportFile } from '@/utils/fileUtil';
import XLSX from 'xlsx'

export default defineComponent({
  components: { LeftTree, StatisticsInfo },
  data() {
    return {
      loading: false,
      project: {},
      workAttendances: [],
      total: 0,
      selection: [],
      workAttendance: {},
      infoVisible: false,
      tableColumns: [
        { type: 'selection' },
        { type: 'index', width: 55, label: '序号' },
        { prop: 'name', label: '姓名', minWidth: 120 },
        { prop: 'phone', label: '电话', minWidth: 120 },
        { label: '所在项目层级', minWidth: 180, formatter: row => this.getProjectLevelName(row) },
        { label: '围栏范围内打卡次数', minWidth: 100, formatter: row => {
          return row.isRange+' / '+row.count;
        }},
        { prop: 'count', label: '打卡次数', minWidth: 100 }
      ],
      params: {
        pageNo: 1,
        length: 20,
        projectFullId: null,
        teamId: null,
        groupId: null,
        query: ''
      }
    }
  },
  computed: {
    ...mapGetters(['orgId']),
    currLabel() {
      let project = this.project;
      if(!project){
        return "";
      }
      let label = project.projectShortName || project.projectName;
      if (project.teamName) {
        label += ' > ' + project.teamName;
      }
      if (project.groupName) {
        label += ' > ' + project.groupName;
      }
      return label
    }
  },
  methods: {
    searchData() {
      this.params.pageNo = 1;
      this.getData();
    },
    pageNoChange(pageNo) {
      this.params.pageNo = pageNo;
      this.getData();
    },
    lengthChange(length) {
      this.params.length = length;
      this.searchData();
    },
    getData() { // 获取人员列表
      this.loading = true;
      statisticsWorkAttendanceByQuery(this.params).then(({data}) => {
        data.data.forEach(wa => {
          wa.clockDate = wa.clockTime.substring(0, 10);
          wa.clockHourMinute = wa.clockTime.substring(11, 16);
        })
        this.workAttendances = data.data;
        this.total = data.page.totalRecords;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    projectChange(project) { // 项目层级改变事件
      if (this.project == project) {
        return;
      }
      this.project = project;
      if (project.type === 'PROJECT') {
        this.params.projectFullId = project.projectId;
        this.params.teamId = null;
        this.params.groupId = null;
      } else if (project.type === 'TEAM') {
        this.params.projectFullId = null;
        this.params.teamId = project.id;
        this.params.groupId = null;
      } else if (project.type === 'GROUP') {
        this.params.projectFullId = null;
        this.params.teamId = null;
        this.params.groupId = project.id;
      }
      this.searchData();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    toInfo(workAttendance) {
      this.workAttendance = workAttendance;
      this.infoVisible = true;
    },
    toExport() {
      if (this.selection && this.selection.length) {
        let exportData = this.getExportData();
              
        let filename = "考勤统计.xlsx"; //文件名称
        let wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(exportData);
        XLSX.utils.book_append_sheet(wb, ws, '考勤统计');  //将数据添加到工作薄
        XLSX.writeFile(wb, filename);
        return;
      }

      exportStatisticsWorkAttendanceByQuery(this.params).then(res => {
        exportFile(res);
      })
    },
    getExportData() { // 遍历生成导出数据
      let exportData = [];
      this.selection.forEach((wa, index) => {
        exportData.push({
          '序号': index + 1,
          '电话': wa.phone,
          '所在项目层级': this.getProjectLevelName(wa),
          '打卡次数': wa.count
        })
      });
      return exportData;
    },
    getProjectLevelName(workAttendance) {
      if (workAttendance.groupName) return workAttendance.groupName;
      if (workAttendance.teamName) return workAttendance.teamName;
      if (workAttendance.projectName) return workAttendance.projectName;
      return '';
    }
  }
})
</script>

<style lang="scss" scoped>
.work-attentance-record {
  height: 100%;
  .left-box {
    width: 20%;
    height: calc(100% - 40px);
    border-right: 1px solid #ccc;
    padding: 20px 10px;
  }
  .right-box {
    .top-tit{
      display: flex;
      .form-cen-tit {
        padding: 5px 25px 5px 5px;
        background: linear-gradient(-45deg,transparent 20px, #0099ff 0) bottom right,
                    linear-gradient(-135deg,transparent 20px,#00548c 0) top right;
        color: white;
        font-size: 14px;
        font-weight: bold;
        min-width: 200px;
      }
    }
    width: calc(80% - 61px);
    padding: 20px;
    .search-condition {
      align-items: center;
      margin-top: 15px;
      .condition-left {
        .el-button {
          margin-left: 15px;
        }
      }
      .condition-right {
        width: 300px;
      }
    }
    .data-table {
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }
}
</style>